export default __webpack_public_path__ + "images/beb3b9a4d85a3582bde90253e7893a01-inkvisitor.svg";